<template>
  <div class="el-tabs-container">
    <el-tabs v-model="activeCode" style="height:100%;padding-left: 6px;">
      <el-tab-pane :label="$t('tab.bom_cost')" name="bomcost">
        <div style="padding: 8px;border-top:1px solid gray;border-bottom:1px solid gray;height:100%;">
          <el-tree :data="data1" node-key="id" default-expand-all :expand-on-click-node="false"
            style="height:100%;overflow-y:auto;overflow-x: auto;" highlight-current>
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>
                <span>{{ node.label }}</span>
              </span>
              <span style="width:30rem">
                <el-tag type="info" effect="dark" style="min-width:120px">总用量：
                  <el-tooltip :content="getBOMInventTotalQty(data) + ''" placement="top">
                    <span>{{ getBOMInventTotalQty(data, 2) }}</span>
                  </el-tooltip>
                </el-tag>
                <el-tag type="warning" effect="dark" class="ml-1" style="min-width:130px">单位成本：
                  <el-tooltip :content="getBOMInventPerPrice(data, 11) + ''" placement="top">
                    <span>{{ getBOMInventPerPrice(data, 6) }}</span>
                  </el-tooltip>
                </el-tag>
                <el-tag effect="dark" style="min-width:150px" class="ml-1">成本额：
                  <el-tooltip :content="getBOMInventCost(data) + ''" placement="top">
                    <span>{{ getBOMInventCost(data, 6) }}</span>
                  </el-tooltip>
                </el-tag>
                <el-tag type="danger" style="min-width:130px" effect="dark" class="ml-1">
                  采购价：{{ getBOMInventPurchPrice(data, 6) }}
                  <!-- <el-tooltip :content="getBOMInventPurchPrice(data)+''" placement="top">
                    <span>{{getBOMInventPurchPrice(data,6)}}</span>
                  </el-tooltip> -->
                </el-tag>
              </span>
            </span>
          </el-tree>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.resources_cost')" name="wrkctr">
        <div style="padding: 8px;border-top:1px solid gray;border-bottom:1px solid gray;height:100%;">
          <el-tree :data="data2" node-key="id" :default-expanded-keys="['r1']" :expand-on-click-node="false"
            style="height:100%;overflow-y:auto;overflow-x: auto;" highlight-current>
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>
                <span>{{ node.label }}</span>
              </span>
              <span>
                <!-- <el-tag v-if="data.children.length==0" type="info" style="min-width:200px" effect="dark" class="ml-2">
                  <el-tooltip :content="getWrkctrDescription(data)+''" placement="top">
                    <span>{{getWrkctrDescription(data,15)}}</span>
                  </el-tooltip>
                </el-tag> -->
                <el-tag v-if="data.children.length == 0" type="info" style="min-width:200px" effect="dark" class="ml-2">
                  <span>{{ getWrkctrDescription(data) }}</span>
                </el-tag>
                <el-tag type="success" effect="dark" class="ml-1" style="min-width:130px">单位成本：
                  <el-tooltip :content="getWrkPerCost(data, 11) + ''" placement="top">
                    <span>{{ getWrkPerCost(data, 6) }}</span>
                  </el-tooltip>
                </el-tag>
                <el-tag type="success" effect="dark" style="min-width:130px" class="ml-2">人工：{{ getLaborCost(data, 6)
                  }}</el-tag>
                <el-tag type="success" style="min-width:130px" effect="dark" class="ml-2">电费：{{ getElectricity(data, 6)
                  }}</el-tag>
              </span>
            </span>
          </el-tree>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.group_cost')" name="costgroup">
        <div style="padding: 8px;overflow-y:auto ;border-top:1px solid gray;border-bottom:1px solid gray;height:100%;">
          <el-tree :data="data3" node-key="id" :default-expanded-keys="[1]" :expand-on-click-node="false"
            style="height:100%;" highlight-current>
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>
                <span>{{ node.label }}</span>
              </span>
              <span>
                <el-tag v-if="data.cost_type == 'O11'" type="success" effect="dark" style="min-width:150px">
                  单位人工：{{ getLaborCost1(data, 6) }}</el-tag>
                <el-tag v-else-if="data.cost_type == 'O23'" type="success" effect="dark" style="min-width:150px">
                  单位电费：{{ getElectricity1(data, 6) }}
                </el-tag>
                <el-tag v-else-if="data.cost_type == 'O24'" type="success" effect="dark" style="min-width:150px">
                  其他费用：{{ data.TransportCost }}
                </el-tag>
                <el-tag v-else type="warning" effect="dark" style="min-width:150px">单位成本：{{ getCostGroupPerPrice(data)
                  }}</el-tag>
              </span>
            </span>
          </el-tree>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div style="padding: 6px;">
      <span style="float:left;color:red;margin-top: 6px;">注：总成本=(BOM总成本额 + 总人工成本 + 总电费)</span>
      <span style="float:right;">
        <el-button size="mini" class="ml-2" type="" @click="on_export"><i class="iconfont icon-print"></i>&nbsp;&nbsp;{{
          $t('common.export') }}
        </el-button>
        <el-tag type="warning" effect="dark" style="min-width:180px;height:28px;padding-top: 3px;" class="ml-2 mt-1">
          <h6>单位成本：{{ getTotalPrice() }}</h6>
        </el-tag>
        <el-tag type="primary" effect="dark" style="min-width:200px;height:28px;padding-top: 3px;" class="ml-2 mt-1">
          <h6>总成本：{{ getTotalCost() }}</h6>
        </el-tag>
      </span>
    </div>
    <div>
      <BaseModal ref="invent_price_modal" :title="invent_price_modal_title" :width="'30%'" @saveData="SaveData"
        :modal="false">
        <template #modal_content>
          <el-form ref="dataForm" label-width="150px" class="demo-dataForm" style="height: 200px">
            <el-col :span="24">
              <el-form-item label="销售公司">
                {{ InventPriceModel.dataAreaId }}
              </el-form-item>
              <el-form-item label="物料名称">
                {{ InventPriceModel.NameAlias }}
              </el-form-item>
              <el-form-item label="报价计算成本价格">
                <el-input type="number" v-model="InventPriceModel.price" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </template>
      </BaseModal>
    </div>
  </div>
</template>

<script>
import * as InventBomVersionController from "../../controllers/sd/InventBomVersionController"
import { export_json_to_excel_by_list } from "../../shared/Export2Excel"
import BaseModal from "../components/modals/baseModal"
export default {
  props: ["data1", "data2", "data3", "total_cost", "cur_product_qty", "dataAreaId"],
  components: {
    BaseModal
  },
  data() {
    return {
      activeCode: "bomcost",
      InventPriceModel: {
        dataAreaId: "",
        ItemId: "",
        NameAlias: "",
        price: 0
      },
      invent_price_modal_title: "调整报价计算成本价格",
      cur_node: {}
    }
  },
  created() {
  },
  methods: {
    //#region 整理显示数据
    getFullNum(num) {
      //处理非数字
      if (isNaN(num)) { return num }

      //处理不需要转换的数字
      var str = '' + num
      if (!/e/i.test(str)) { return num }

      return (num).toFixed(18).replace(/\.?0+$/, "")
    },
    getBOMInventCost(data, spc) {
      if (spc)
        return this.getFullNum(_.round(data.invent_cost, spc))
      else
        return this.getFullNum(_.round(data.invent_cost, 11))
    },
    getBOMInventPurchPrice(data, spc) {
      if (spc)
        return _.round(data.purch_price, spc)
      else
        return _.round(data.purch_price, 6)
    },
    getBOMInventTotalQty(t, spc) {
      let realQty = t.real_qty
      if (t.TEC_SpoilageType) {
        let spoilage_type_m = _.find(this.$store.state.biz_data.baseData.SpoilageTypeRatio, { SpoilageType: t.TEC_SpoilageType })
        if (spoilage_type_m) {
          let dec = 2
          let unit_m = _.find(this.$store.state.biz_data.baseData.UnitOfMeasure, { Symbol: t.DW_InventUnitId })
          if (unit_m)
            dec = unit_m.DecimalPrecision

          switch (spoilage_type_m.carryType) {
            case "进一": realQty = _.ceil(t.real_qty, dec); break
            case "四舍五入": realQty = _.round(t.real_qty, dec); break
            default: realQty = _.round(t.real_qty, dec); break
          }
        }
        else {
          let dec = 2
          let unit_m = _.find(this.$store.state.biz_data.baseData.UnitOfMeasure, { Symbol: t.DW_InventUnitId })
          if (unit_m)
            dec = unit_m.DecimalPrecision
          realQty = _.round(t.real_qty, dec)
        }
      }
      return realQty
      // if (spc)
      //   return _.round(t.real_qty, spc);
      // else
      //   return _.round(t.real_qty, 6);
    },
    ///计算bom成本额单价
    getBOMInventPerPrice(data, spc) {
      if (spc)
        return this.getFullNum(_.round(data.invent_cost / parseFloat(data.product_qty), spc))
      else
        return this.getFullNum(_.round(data.invent_cost / parseFloat(data.product_qty), 11))
    },
    //获取成本组单位成本
    getCostGroupPerPrice(data) {
      return _.round(data.price, 6)
    },
    //获取人工成本
    getLaborCost(data, spc) {
      if (data.LaborCost == undefined) {
        return 0
      }
      if (spc)
        return _.round(data.LaborCost, spc)
      else
        return _.round(data.LaborCost, 6)
    },
    getLaborCost1(data, spc) {
      if (data.LaborCost == undefined) {
        return 0
      }
      if (spc)
        return _.round(data.LaborCost / this.cur_product_qty, spc)
      else
        return _.round(data.LaborCost / this.cur_product_qty, 6)
    },
    getWrkPerCost(data, spc) {
      let wcost1 = data.LaborCost == undefined ? 0 : data.LaborCost
      let wcost2 = data.Electricity == undefined ? 0 : data.Electricity
      if (spc)
        return _.round((wcost1 + wcost2) / this.cur_product_qty, spc)
      else
        return (wcost1 + wcost2) / this.cur_product_qty
    },
    getElectricity(data, spc) {
      if (data.Electricity == undefined) {
        return 0
      }
      if (spc)
        return _.round(data.Electricity, spc)
      else
        return _.round(data.Electricity, 6)
    },
    getElectricity1(data, spc) {
      if (data.Electricity == undefined) {
        return 0
      }
      if (spc)
        return _.round(data.Electricity / this.cur_product_qty, spc)
      else
        return _.round(data.Electricity / this.cur_product_qty, 6)
    },
    getWrkctrDescription(data, spc) {
      let rt_str = ""
      let labels = ["资源：", "运行时间：", "人数：", "设备功率：", "现行单位工价：", "原单位工价："]
      let values = []
      values.push(data.WrkCtrId)
      values.push(_.round((data.RealQty / data.UPH + data.SetupTime), 6))
      values.push(data.SEI_WorkerCount)
      values.push(data.TEC_EquipPower)
      values.push(data.cPerWorkerPrice)
      values.push(data.PerWorkerPrice ? data.PerWorkerPrice : 0)
      for (var i in labels) {
        rt_str += labels[i] + values[i] + "，"
      }
      rt_str = _.trimEnd(rt_str, "，")
      if (spc) {
        return rt_str.substring(0, spc) + "..."
      }
      return rt_str
    },
    getTotalCost() {
      return _.round(this.total_cost, 6)
    },
    getTotalPrice() {
      if (this.cur_product_qty > 0)
        return _.round(this.total_cost / this.cur_product_qty, 6)
      else
        return 0
    },
    //#endregion
    //#region node点击
    handleNodeClick(data) {

      this.cur_node = data
      this.InventPriceModel.ItemId = data.ItemId
      this.InventPriceModel.NameAlias = data.label
      this.InventPriceModel.price = data.purch_price
      this.InventPriceModel.dataAreaId = this.dataAreaId
      this.$refs.invent_price_modal.show()
    },
    async SaveData(cb) {
      //数据验证
      let am = _.cloneDeep(this.InventPriceModel)
      delete am.NameAlias
      delete am.CompanyName
      let p = {}
      p.add = am//新增或者修改后台判断
      //检查价格是否存在
      let exists_dt = await InventBomVersionController.methods.getDataInventPrice({ dataAreaId: am.dataAreaId, ItemId: am.ItemId })
      if (exists_dt && exists_dt.length > 0 && exists_dt[0] && exists_dt[0].length > 0) {
        await this.$confirm('价格已存在，是否继续保存？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(() => {
          cb(false)
          return
        })
        delete p.add
        am.id = exists_dt[0][0]
        p.edit = am//新增或者修改后台判断
      }
      let rt = await InventBomVersionController.methods.saveDataInventPrice(p)
      if (rt) {
        // this.cur_node.purch_price = am.price;
        this.msgToasts(this.$t("notify.action_successfully") + "，请重新计算！", "success")
        cb(false)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#endregion
    //#region 导出
    on_export() {
      // console.log(this.data1, this.data2, this.data3)
      if (this.data1.length == 0 || this.data2.length == 0 || this.data3.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      let _loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        background: "rgba(0, 0, 0, 0.7)"
      })
      let dt = [], colors = ['507bf3', 'fddf4a', 'f5c4ac', 'f3f586', 'efa2db', 'f37c7c']
      //bom成本额
      let sheet1_dt = { sheetName: "BOM成本额", sheetStyle: true, data: [] }
      sheet1_dt.data.push({ color: '68aff9', data: ["物料", "总用量", "单位成本", "成本额", "采购价", "级别", "是否末级"] })
      this.getSheetData1(this.data1, sheet1_dt, colors, 0)
      dt.push(sheet1_dt)
      //资源成本
      let sheet2_dt = { sheetName: "资源成本", data: [] }
      sheet2_dt.data.push(["物料", "资源", "UPH", "运行时间", "人数", "设备功率", "单位工价", "单位成本", "人工", "电费"])
      this.getSheetData2(this.data2, sheet2_dt)
      dt.push(sheet2_dt)
      //成本组
      let sheet3_dt = { sheetName: "成本组", data: [] }
      sheet3_dt.data.push(["成本组", "级别", "单位成本"])
      this.getSheetData3(this.data3, sheet3_dt, 0)
      dt.push(sheet3_dt)
      export_json_to_excel_by_list(dt, "BOM成本表", _loading)
    },
    getSheetData1(dt, p, colors, sq) {
      let eps = "", isq = sq * 4
      for (var i = 1; i <= isq; i++) {
        eps = eps + " "
      }
      sq++
      _.each(dt, (t) => {
        let m = []
        m.push(eps + t.label)
        m.push(t.real_qty)
        m.push(_.round((t.invent_cost / t.product_qty), 6))
        m.push(t.invent_cost)
        m.push(t.purch_price)
        m.push(sq)
        p.data.push({ color: colors[sq], data: m })
        if (t.children && t.children.length > 0) {
          m.push('否')
          this.getSheetData1(t.children, p, colors, sq)
        }
        else
          m.push('是')
      })
    },
    getSheetData2(dt, p) {
      _.each(dt, (t) => {
        let m = []
        m.push(t.label)
        m.push(t.WrkCtrId)
        m.push(t.UPH)
        let runTime = _.round((t.RealQty / t.UPH + t.SetupTime), 6)
        m.push(_.isNaN(runTime) ? "" : runTime)
        m.push(t.SEI_WorkerCount)
        m.push(t.TEC_EquipPower)
        m.push(t.cPerWorkerPrice)
        m.push(_.round(((t.LaborCost + t.Electricity) / this.cur_product_qty), 6))
        m.push(t.LaborCost)
        m.push(t.Electricity)
        p.data.push(m)
        if (t.children && t.children.length > 0) {
          this.getSheetData2(t.children, p)
        }
      })
    },
    getSheetData3(dt, p, sq) {
      let eps = "", isq = sq * 4
      for (var i = 1; i <= isq; i++) {
        eps = eps + " "
      }
      sq++
      _.each(dt, (t) => {
        let m = []
        m.push(eps + t.label)
        m.push(sq)
        if (t.cost_type == 'O11')
          m.push(t.LaborCost / this.cur_product_qty)
        else if (t.cost_type == 'O23')
          m.push(t.Electricity / this.cur_product_qty)
        else
          m.push(t.price)

        p.data.push(m)
        if (t.children && t.children.length > 0) {
          this.getSheetData3(t.children, p, sq)
        }
      })
    }
    //#endregion
  },
}
</script>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

/* .el-tree-node__content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 26px;
  cursor: no-drop;
} */
.bom .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #ffa5a5;
  /* color: #fff; */
}

.hb_table_routecost_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}

.bom .el-card__body,
.el-main {
  padding: 0px;
}

.bom .el-tree-node.is-expanded>.el-tree-node__children {
  display: contents;
}
</style>
